import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../../shared';

import { CampanhaItemFormComponent } from './campanha-item-form.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CampanhaItemFormComponent
    ],
    exports: [
        CampanhaItemFormComponent
    ]
})
export class CampanhaItemFormModule { }
